var AuthFormConfirmInputCode = ( function($) {

    var AuthFormConfirmInputCode = function(options) {
        this.init(options);
    };

    var Self = AuthFormConfirmInputCode;
    Self.className = 'AuthFormConfirmInputCode';
    var Parent = ActionformAbstract;

    var def = ActionformAbstract.def;

    // "inherit"
    Self.prototype = Object.create(Parent.prototype);
    Self.prototype.constructor = Self;

    Self.prototype.init = function (options) {
        var that = this;

        Parent.prototype.init.call(that, options);

        // if not in modal mode (separate page e.g.), get `sent_to` and request code timelimit from storage when action would be shown 
        if (!that.isModalMode()) {
            var sent_to = that.__getPrevActionData('number-sent-to'),
                login = that.__getPrevActionData('number'),
                login_type = that.__getPrevActionData('login-type'),
                limit_time = that.__getPrevActionData('next-request-timelimit');
            that.setSentToText(login_type);
            that.setSentTo(sent_to);
            that.setLogin(login);
            that.setupCodeRequestAction(limit_time);
        }
    };

    Self.prototype.initVars = function (options) {
        var that = this;
        options = options || {};

        that.selectors = {
            form: '.js-form-confirm-input-code',
            next_action: '',
            previous_action: '.js-form-confirm-input-login',
            sent_to: '.js-sent-to',
            sent_to_text: '.js-text-sent-to',

            login: '.js-login',
            input_code: '.js-input-code',
            request_code_actions_wrapper: '.js-request-code-actions-wrapper',
            request_code_timelimit_wrapper: '.js-request-code-timelimit-wrapper',
            request_code_timelimit: '.js-request-code-timelimit',
            button_request_code:'.js-button-request-code',
            error_request_code: '.js-error-request-code',
        };

        that.data_keys = {
            next_code_time_limit: 'time-limit',
        };

        // pass `url` in the options!

        that.method = 'POST';

        that.has_success_screen = true;

        that.request_code_url = options.request_code_url || '';
        // to get data, saved in the local storage, when not in modal mode (next action is separate page e.g.)
        that.action_data_key_prefix = def(options.action_data_key_prefix, 'avia/auth-confirm');

        that.timelimit = null;

        Parent.prototype.initVars.call(that, options);
        that.className = Self.className;
    };

    Self.prototype.initDomElements = function () {
        var that = this;

        Parent.prototype.initDomElements.call(that);

        that.$success_wrapper = that.$wrapper.find(that.selectors.success_wrapper);

        that.$sent_to = that.$wrapper.find(that.selectors.sent_to);
        that.$sent_to_text = that.$wrapper.find(that.selectors.sent_to_text);
        that.$login = that.$wrapper.find(that.selectors.login);

        that.$input_code = that.$form_wrapper.find(that.selectors.input_code);
        that.$request_code_actions_wrapper = that.$form_wrapper.find(that.selectors.request_code_actions_wrapper);
        that.$request_code_timelimit_wrapper = that.$form_wrapper.find(that.selectors.request_code_timelimit_wrapper);
        that.$request_code_timelimit = that.$form_wrapper.find(that.selectors.request_code_timelimit);
        that.$button_request_code = that.$form_wrapper.find(that.selectors.button_request_code);
        that.$error_request_code = that.$form_wrapper.find(that.selectors.error_request_code);
    };
    
    Self.prototype.initEventHandlers = function () {
        var that = this;

        Parent.prototype.initEventHandlers.call(that);

        that.$button_request_code.on('click', function (e) {
            e.preventDefault();
            that.__requestCode();
        });
    };

    Self.prototype.onActionShown = function () {
        var that = this,
            limit_time = that.$request_code_timelimit.attr('data-' + that.data_keys.next_code_time_limit);

        Parent.prototype.onActionShown.call(that);

        that.setupCodeRequestAction(limit_time);
    };

    Self.prototype.onDoneSubmitHandleSuccess = function (response) {
        var that = this,
            handlers = that.onDoneSubmitHandlers();

        if (that.isRedirectResponse(response)) {
            var url = that.getRedirectUrl(response);
            return (handlers.redirect && handlers.redirect(url));
        }
        else { // show next screen as in modal mode by default
            return (handlers.goToNext && handlers.goToNext(response));
        }
    };

    Self.prototype.showErrors = function (errors) {
        errors = errors || [];

        var that = this,
            request_limit_error_index = errors.findIndex(er => er.code == 9102), // if someday we don’t need alert displaying that error, we could delete that error from the `errors` by index
            inputs_limit_error_index = errors.findIndex(er => er.code == 9101),
            confirmation_blocked_error_index = errors.findIndex(er => er.code == 9100);

        if (-1 !== request_limit_error_index || -1 !== confirmation_blocked_error_index) {
            that.showRequestCodeError();
            // errors.splice(request_limit_error_index, 1);
        }
        if (-1 !== inputs_limit_error_index || -1 !== confirmation_blocked_error_index) {
            that.disableCodeInput();
            that.toggleSubmitButtonAvailability(false);
        }
        Parent.prototype.showErrors.call(that, errors);
    };

    Self.prototype.initCallbacks = function (options) {
        var that = this;

        if (that.isModalMode()) {
            var modal = that.$modal.data('modal');
            modal.onClosed = function () {
                // reload page only if current screen or its success screen is active
                // (do not reload on the previous screen close)
                if (that.isActionActive() || that.isSuccessScreenActive()) {
                    window.location.reload();
                }
            };
        }

        Parent.prototype.initCallbacks.call(that, options);
    };

    // (?)do not remove code requests error on submit
    // Self.prototype.clearErrors = function () {
    //     var that = this;
    //     that.hideRequestCodeError();
    //     Parent.prototype.clearErrors.call(that);
    // };

    Self.prototype.disableCodeInput = function () {
        var that = this;
        UIInput.prototype.disable(that.$input_code);
    };

    Self.prototype.enableCodeInput = function () {
        var that = this;
        UIInput.prototype.enable(that.$input_code);
    };

    Self.prototype.hideRequestCodeActionsWrapper = function () {
        var that = this;
        that.$request_code_actions_wrapper.hide();
    };

    Self.prototype.hideRequestCodeTimelimit = function () {
        var that = this;
        that.$request_code_timelimit_wrapper.hide();
        // if all children in the $request_code_actions_wrapper are hidden, hide it too
        if (that.isAllRequestCodeActionsHidden()) {
            that.hideRequestCodeActionsWrapper();
        }
    };

    Self.prototype.hideRequestCodeError = function () {
        var that = this;
        that.$error_request_code.hide();
        // if all children in the $request_code_actions_wrapper are hidden, hide it too
        if (that.isAllRequestCodeActionsHidden()) {
            that.hideRequestCodeActionsWrapper();
        }
    };

    Self.prototype.hideRequestCodeButton = function () {
        var that = this;
        that.$button_request_code.hide();
        // if all children in the $request_code_actions_wrapper are hidden, hide it too
        if (that.isAllRequestCodeActionsHidden()) {
            that.hideRequestCodeActionsWrapper();
        }
    };

    Self.prototype.showRequestCodeActionsWrapper = function () {
        var that = this;
        that.$request_code_actions_wrapper.show();
    };

    Self.prototype.showRequestCodeTimelimit = function () {
        var that = this;

        that.hideRequestCodeButton();
        that.hideRequestCodeError();

        that.$request_code_timelimit_wrapper.show();

        that.showRequestCodeActionsWrapper();
    };

    Self.prototype.showRequestCodeError = function () {
        var that = this;

        that.hideRequestCodeTimelimit();
        that.hideRequestCodeButton();

        that.$error_request_code.show();

        that.showRequestCodeActionsWrapper();
    };

    Self.prototype.showRequestCodeButton = function () {
        var that = this;

        that.hideRequestCodeTimelimit();
        that.hideRequestCodeError();

        that.$button_request_code.show();

        that.showRequestCodeActionsWrapper();
    };

    Self.prototype.isAllRequestCodeActionsHidden = function () {
        var that = this;
        return that.$request_code_actions_wrapper.children(':visible').length <= 0;
    };

    Self.prototype.disableRequestCodeButton = function () {
        var that = this;
        that.$button_request_code.attr('disabled', 'disabled');
    };

    Self.prototype.enableRequestCodeButton = function () {
        var that = this;
        that.$button_request_code.attr('disabled', null);
    };

    Self.prototype.__getPrevActionData = function (key) {
        var that = this;

        key = that.action_data_key_prefix + '-' + key;

        return sessionStorage.getItem(key);
    };

    Self.prototype.__requestCode = function () {
        var that = this,
            url = that.request_code_url,
            method = 'POST',
            data = {login: that.$login.val()};

        if (!url) {
            that.showErrors(
                [{
                    _alert: that.getLocalePhrase('Error')
                }]
            );
            return;
        }

        $.ajax({
            url: url,
            method: method,
            data: data,
            dataType: 'json',
            beforeSend: function () {
                that.disableRequestCodeButton();
            }
        })
            // `always` must be registered before `done` and `fail`
            .always(function () {
                that.clearForm(); // clear form and enable all controls after request code, but before handle fail (to display errors)
                that.enableRequestCodeButton();
            })
            .done(function (response) {
                var ok = that.isResponseSuccessful(response),
                    data = (response && response.data) || {},
                    errors = (response && response.errors) || [{_alert: that.getLocalePhrase('error')}];

                if (ok && data.hasOwnProperty('next_code_time')) {
                    that.setupCodeRequestAction(data.next_code_time);
                } else {
                    that.onDoneSubmitHandleFail(errors, response);
                }
            })
            .fail(function (jqXHR) {
                that.onDoneSubmitHandleFail([
                    {
                        _alert: that.getLocalePhrase('error'),
                        message: jqXHR.responseText
                    }
                ], null);
            });
    };

    Self.prototype.__clearTimelimit = function () {
        var that = this;

        if (!that.timelimit) {
            return;
        }
        that.timelimit.clear && that.timelimit.clear();
        that.timelimit = null;
    };
    
    Self.prototype.__setupTimelimit = function (time) {
        var that = this;

        that.timelimit = new UITimelimit({
            $wrapper: that.$request_code_timelimit,
            timelimit: time,
            no_units: true,
            onTimeLeft: function () {
                that.showRequestCodeButton();
            }
        });
    };

    Self.prototype.setupCodeRequestAction = function (limit_time) {
        var that = this;

        limit_time = parseInt(limit_time, 10);

        that.__clearTimelimit();

        if (limit_time && limit_time !== -1) {
            that.__setupTimelimit(limit_time);
            that.showRequestCodeTimelimit();
        }
        // code requests limit is reached
        else if (limit_time === -1) {
            that.showRequestCodeError();
        }
        // time limit is zero or empty
        else {
            that.showRequestCodeButton();
        }
    };

    Self.prototype.setSentTo = function (sent_to) {
        var that = this;
        that.$sent_to.text(sent_to);
    };

    Self.prototype.setSentToText = function (login_type) {
        var that = this;
        that.$sent_to_text.text(
            that.getLocalePhrase('sent_to.' + login_type, that.getLocalePhrase('sent_to.unknown'))
        );
    };

    Self.prototype.setLogin = function (login) {
        var that = this;
        that.$login.val(login);
    };

    return Self;
})(jQuery);
